import { AssetSchema } from '../types/asset.types';
import { AssetTypeId, SystemTypeId } from './assetSchema.types';

type GetAssetTypeIdParams =
	| {
			systemType: string;
			assetType: string;
	  }
	| { assetSchema: AssetSchema };

export function getNewAssetIds(params: GetAssetTypeIdParams): {
	systemTypeId: SystemTypeId;
	assetTypeId: AssetTypeId;
} {
	if ('assetSchema' in params) {
		return getNewAssetIdsFromSchema(params.assetSchema);
	} else {
		return getNewAssetIdsFromString(params.systemType, params.assetType);
	}
}

function getNewAssetIdsFromSchema(assetSchema: AssetSchema): {
	systemTypeId: SystemTypeId;
	assetTypeId: AssetTypeId;
} {
	const assetType = assetSchema.id;
	const systemType = assetSchema.systemType.id;

	if (systemType === 'SanitarySewer' && assetType === 'wwPipe') {
		return {
			systemTypeId: {
				id: 'SanitarySewer',
				externalId: 'Sanitary Sewer',
			},
			assetTypeId: {
				id: 'wwPipe',
				externalId: 'pipe',
			},
		};
	}

	if (systemType === 'WaterDistribution' && assetType === 'pipe') {
		return {
			systemTypeId: {
				id: 'WaterDistribution',
				externalId: 'Water Distribution',
			},
			assetTypeId: {
				id: 'pipe',
				externalId: 'pipe',
			},
		};
	}

	return {
		systemTypeId: {
			id: systemType,
			externalId: systemType,
		},
		assetTypeId: {
			id: assetType,
			externalId: assetType,
		},
	};
}

function getNewAssetIdsFromString(
	systemType: string,
	assetType: string,
): { systemTypeId: SystemTypeId; assetTypeId: AssetTypeId } {
	if (
		['Sanitary Sewer', 'SanitarySewer'].includes(systemType) &&
		['pipe', 'wwPipe'].includes(assetType)
	) {
		return {
			systemTypeId: {
				id: 'SanitarySewer',
				externalId: 'Sanitary Sewer',
			},
			assetTypeId: {
				id: 'wwPipe',
				externalId: 'pipe',
			},
		};
	}

	if (
		['Water Distribution', 'WaterDistribution'].includes(systemType) &&
		['pipe'].includes(assetType)
	) {
		return {
			systemTypeId: {
				id: 'WaterDistribution',
				externalId: 'Water Distribution',
			},
			assetTypeId: {
				id: 'pipe',
				externalId: 'pipe',
			},
		};
	}

	return {
		systemTypeId: {
			id: systemType,
			externalId: systemType,
		},
		assetTypeId: {
			id: assetType,
			externalId: assetType,
		},
	};
}
